import {management} from '../../../../index.js' //api
import {VolumeRepository} from "../../../infra/knex/repositories/volume"
import {SaveVolumeUseCase} from "./saveDailyVolumesUseCase"
// const {SaveVolumeController}=require("./saveDailyVolumesController")

// module.exports=()=>{
//     const useCase=new SaveVolumeUseCase(new VolumeRepository(management))
//     const controller=new SaveVolumeController(useCase)
//     return controller
// }

export  const saveVolumeUseCase=new SaveVolumeUseCase(new VolumeRepository(management))
